import {ErrorsResponse, IError} from "../models/common/IErrorsResponse";

export default function createErrorsResponseFromJSON(json: object = {}){
  //@ts-ignore
  const errors = json.errors as IError[];
  //@ts-ignore
  const title = json.title as string;
  //@ts-ignore
  const type = json.type || "Unknown" as string;
  return new ErrorsResponse("", type, errors, title);
}
